import type { NextPage } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

import type { Item, Pagination } from '@/modules/project'
import type { GetItemsResult } from '@/modules/projectResidentsOpinion/interface'

import Dayjs from '@/components/dayjs'
import Button from '@/components/button/GGButton'
import ArrowIcon from '@/components/svgIcons/Arrow2'
import CircleIcon from '@/components/svgIcons/Circle'

import ItemBasicInfo from './itemBasicInfo'

import style from './item.module.css'


interface IProps {
  projectIdx: number;
  item: Item;
  opinion: {
    items: GetItemsResult["items"];
    // pagination: Pagination;
  }
}

const Component: NextPage<IProps> = ({ projectIdx, item, opinion }) => {
  const Router = useRouter();
  const paginationInfo = undefined;
  // const paginationInfo: IPagination = {
  //   limit: opinion.pagination.limit,
  //   pageItemLength: 10,
  //   totalPages: opinion.pagination.totalPage,
  //   totalRecords: opinion.pagination.totalRecord,
  // };

  const getAsteriskMaskedString = useCallback((str: string) => {
    // It doesn't work with Safari
    // @See : https://caniuse.com/js-regexp-lookbehind
    // return str.replace(/(?<=.{1})./g, '*');
    return str[0] + str.substring(1).replace(/./g, '*');
  }, []);


  return (
    <div className='flex flex-col items-center'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center my-16'>
        <div className='w-full'>
          <h1 className={`${style.h1} pb-6 border-b-2 border-b-[#111111]`}>주민의견 제출</h1>

          <ItemBasicInfo item={item} />

          <section className='mt-12'>
            <div className='flex items-center justify-between'>
              <h2 className={`${style.h2} !my-0`}>
                <CircleIcon /> 주민의견 제출
              </h2>
              <div>
                <button
                  className='flex items-center justify-center text-white bg-gg-green h-[60px] w-[240px] hover:bg-green-600'
                  onClick={() => Router.push(`/opinion/participation/${projectIdx}/report/add`)}
                >
                  <span className='pr-3 text-[18px] text-medium'>주민의견 제출하기</span>
                  <ArrowIcon direction='right' color="#FFFFFF" />
                </button>
              </div>
            </div>

            <div className='mt-8'>
              <div className='mt-8'>
                <table className={style.table}>
                  <thead>
                    <tr>
                      <th>번호</th>
                      <th>제목</th>
                      <th>제출자</th>
                      {/* <th>첨부파일</th> */}
                      <th>등록일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {opinion.items && opinion.items.map((item, index) => (
                      <tr key={index} className="hover:bg-blue-50" onClick={() => (Router.push(`/opinion/participation/${projectIdx}/report/${item.idx}`))}>
                        <td><Link href={`/opinion/participation/${projectIdx}/report/${item.idx}`}><a>{item.idx}</a></Link></td>
                        <td className='!text-left'><Link href={`/opinion/participation/${projectIdx}/report/${item.idx}`}><a>{item.title}</a></Link></td>
                        <td>{getAsteriskMaskedString(item.writer || '')}</td>
                        {/* <td>{item.isAttachFile ? '아이콘' : '-'}</td> */}
                        <td><Dayjs format="dateDot">{item.createdAt}</Dayjs></td>
                      </tr>
                    ))}
                    {opinion.items && opinion.items.length === 0 && (
                      <tr className='hover:!bg-white odd:!bg-white even:!bg-white hover:!cursor-auto'>
                        <td colSpan={8} className='py-24 text-center'>
                          조회된 데이터가 없습니다.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* <div className='my-16'>
              {(opinion.items && opinion.pagination) && <PaginationComponent {...paginationInfo} />}
            </div> */}

          </section>

          <div className='my-16 text-center'>
            <Button className='w-[180px] h-[60px]' onClick={() => Router.back()}>목록으로</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
